import { createFileRoute } from "@tanstack/react-router";
import { LoginPage } from "./-login/LoginPage";

export const Route = createFileRoute("/login")({
  validateSearch: (
    s: Record<string, unknown>,
  ): { next?: string; error?: string; step?: "two-factor" } => ({
    ...(typeof s.next === "string" ? { next: s.next } : {}),
    ...(typeof s.error === "string" ? { error: s.error } : {}),
    ...(s.step === "two-factor" ? { step: "two-factor" as const } : {}),
  }),
  staticData: { title: "Sign in" },
  component: LoginPage,
});
